import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import Button from 'components/field/Button';
import LottiePlayer from 'components/global/LottiePlayer';
import Typography from 'components/global/Typography';

import PATHS from 'utils/paths';

import { faHome } from '@fortawesome/pro-solid-svg-icons';

import * as S from './ErrorPages.styled';

const ErrorPage = () => {
	const { pathname } = useLocation();
	const navigate = useNavigate();
	const isErrorPath = pathname === PATHS.ERROR;

	useEffect(() => {
		isErrorPath && navigate(PATHS.BASE, { replace: true, state: { error: true } });
	}, []);

	return !isErrorPath ? (
		<div>
			<ErrorPageContent />
		</div>
	) : null;
};

export const ErrorPageContent = () => {
	const navigate = useNavigate();

	return (
		<S.Container>
			<LottiePlayer name="alert-error-icon" width="100%" height="25%" />
			<Typography variant="h2" style={{ marginBottom: 'var(--margin-2)', fontWeight: 500 }}>
				errorPage.header
			</Typography>
			<Typography
				style={{
					marginBottom: 'var(--margin-4)',
					width: '40rem'
				}}
				align="center"
				fontWeight={500}
				noWrap>
				errorPage.content
			</Typography>
			<Button icon={faHome} label="visitHomepage" onClick={() => navigate(PATHS.BASE, { replace: true })} />
		</S.Container>
	);
};

export default ErrorPage;
